import React from "react";
import { Box, IconButton } from "@mui/material";
import "./index.scss";
import { Images } from "../../assets/common";
export default function VideoCard({ video, onVideoClick }) {
  return (
    <Box className="__video_card" onClick={onVideoClick}>
      <iframe
        allow="autoplay"
        src={video}
        className="__video_card_image"
        allowFullScreen
      ></iframe>

      <Box className="_play_video">
        <img src={Images.play} alt="play" />
      </Box>
    </Box>
  );
}
